export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./email.vue?vue&type=template&id=59c82cc3"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/payments/email.vue?vue&type=template&id=59c82cc3
// module id = 9DxD
// module chunks = 0